import React from "react";
import { View, StyleSheet } from "react-native";
import FileList from "../components/file-list";
import { getFavorites } from "../util/api";
import { ItemCount } from "../components/item-count";
import { useQuery } from "react-query";
import { useAuthScene } from "./Auth";

function FavoritesScene() {
  const { data: files } = useQuery("favorites", getFavorites, {
    initialData: [],
  });
  return (
    <View style={styles.container}>
      <View style={styles.contentContainer}>
        <FileList files={files} />
        <ItemCount itemName="Favorites" count={files.length} />
      </View>
    </View>
  );
}

export default useAuthScene(FavoritesScene);

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    width: "100%",
    maxWidth: 760,
    marginLeft: "auto",
    marginRight: "auto",
  },
});
